/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-07-23 21:03:45
 * @LastEditTime: 2022-01-10 14:02:44
 */
// import campaignImg from 'assets/images/icon/campagn.svg'
const nav = [
  {
    className: 'iconfont icon-a-Homexiantiao',
    name: 'Home',
    path: '/wap/home'
  },
  {
    className: 'iconfont icon-a-dingdanxiantiao1',
    name: 'Order',
    path: '/wap/order'
  }, {
    // className: 'iconfont icon-xiadan icon-xiadan-self',
    content: `<img src="images/icon/campagn.svg">`,
    name: 'Campaign',
    path: '/wap/campaign?serviceType=CAMPAIGN'
  }, {
    className: 'iconfont icon-a-kefuxiantiao',
    name: 'Support',
    path: '/wap/support'
  },
  {
    className: 'iconfont icon-wode',
    name: 'Me',
    path: '/wap/mine'
  }
];

export { nav };
